export class GoogleMapsLoader {
}
//# sourceMappingURL=google-maps.abstract.js.map